import AllRoutes from "./routes/Routes";
import 'animate.css';


export default function App() {
  return (
      <AllRoutes />
  )
}